var Column = function Column() {
  return null;
};

export default Column;